import {
  faPepperHot,
  faHatCowboy,
  faHandHoldingUsd,
  faClipboardList,
  faTrophyAlt,
  faBurgerSoda,
  faUtensils,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import EventNoteIcon from '@material-ui/icons/EventNote';
import InfoIcon from '@material-ui/icons/Info';
import LocalDiningIcon from '@material-ui/icons/LocalDining';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import NotesIcon from '@material-ui/icons/Notes';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import QueueMusicIcon from '@material-ui/icons/QueueMusic';
import SchoolIcon from '@material-ui/icons/School';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import styles from 'assets/jss/material-kit-pro-react/components/headerLinksStyle.jsx';
import classNames from 'classnames';
import ContactForm from 'components/ContactForm/ContactForm';
import Button from 'components/CustomButtons/Button.jsx';
import CustomDropdown from 'components/CustomDropdown/CustomDropdown.jsx';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  // const easeInOutQuad = (t, b, c, d) => {
  //   t /= d / 2
  //   if (t < 1) return (c / 2) * t * t + b
  //   t--
  //   return (-c / 2) * (t * (t - 2) - 1) + b
  // }

  // const smoothScroll = (e, target) => {
  //   if (
  //     typeof window !== "undefined" &&
  //     window.location.pathname === "/sections"
  //   ) {
  //     var isMobile = navigator.userAgent.match(
  //       /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
  //     )
  //     if (isMobile) {
  //       // if we are on mobile device the scroll into view will be managed by the browser
  //     } else {
  //       e.preventDefault()
  //       var targetScroll = document.getElementById(target)
  //       scrollGo(document.documentElement, targetScroll.offsetTop, 1250)
  //     }
  //   }
  // }
  // const scrollGo = (element, to, duration) => {
  //   var start = element.scrollTop,
  //     change = to - start,
  //     currentTime = 0,
  //     increment = 20

  //   var animateScroll = function() {
  //     currentTime += increment
  //     var val = easeInOutQuad(currentTime, start, change, duration)
  //     element.scrollTop = val
  //     if (currentTime < duration) {
  //       setTimeout(animateScroll, increment)
  //     }
  //   }
  //   animateScroll()
  // }
  // var onClickSections = {}

  const { dropdownHoverColor } = props;
  const classes = useStyles();
  return (
    <List className={classes.list + ' ' + classes.mlAuto}>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="Info"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          buttonIcon={InfoIcon}
          dropdownList={[
            <Link key="about" to="/about" className={classes.dropdownLink}>
              <NotesIcon className={classes.dropdownIcons} />
              About
            </Link>,
            <Link key="tickets" to="/tickets" className={classes.dropdownLink}>
              <ConfirmationNumberIcon className={classes.dropdownIcons} />
              Tickets
            </Link>,
            <Link key="travel" to="/travel" className={classes.dropdownLink}>
              <DriveEtaIcon className={classes.dropdownIcons} />
              Travel
            </Link>,
            // <a
            //   key="apparel"
            //   href="https://mkapparel.tuosystems.com/stores/chilimania"
            //   className={classes.dropdownLink}
            //   target="_blank"
            //   rel="noopener noreferrer"
            // >
            //   <LocalMallIcon className={classes.dropdownIcons} />
            //   Apparel
            // </a>,
            <Link
              key="food-vendors"
              to="/food-vendors"
              className={classes.dropdownLink}
            >
              <FontAwesomeIcon
                className={classNames(classes.dropdownIcons, 'fa-fw')}
                icon={faBurgerSoda}
              />
              Food Vendors
            </Link>,
            <Link
              key="public-tasting"
              to="/public-tasting"
              className={classes.dropdownLink}
            >
              <FontAwesomeIcon
                className={classNames(classes.dropdownIcons, 'fa-fw')}
                icon={faUtensils}
              />
              Public Tasting
            </Link>,
            <Link
              key="scholarships"
              to="/scholarships"
              className={classes.dropdownLink}
            >
              <SchoolIcon className={classes.dropdownIcons} />
              Scholarships
            </Link>,
            <Link key="faq" to="/faq" className={classes.dropdownLink}>
              <QuestionAnswerIcon className={classes.dropdownIcons} />
              FAQ
            </Link>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="Compete"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          buttonIcon={LocalDiningIcon}
          dropdownList={[
            <Link
              key="chili-cook-off"
              to="/chili-cook-off"
              className={classes.dropdownLink}
            >
              <FontAwesomeIcon
                className={classes.dropdownIcons}
                icon={faPepperHot}
              />
              Chili Cook-Off
            </Link>,
            <Link
              key="salsa-contest"
              to="/salsa-contest"
              className={classes.dropdownLink}
            >
              <SvgIcon
                className={classes.dropdownIcons}
                fill="current-color"
                id="Capa_1"
                data-name="Capa 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 486.98 512"
              >
                <title>tomato</title>
                <path
                  fill="current-color"
                  d="M460.05,183.27c-26.06,13.86-56.61,17.87-88.21,9,3.28,35.33-7,60.36-20.56,86.5-46.63-3.05-77.13-20.7-95.27-43.19C238,258,207.51,275.74,160.73,278.8c-12.48-24-24-49.41-20.56-86.5-30.3,8.52-61.16,5.37-88.2-9.05C-7.49,267.56-2.32,385.9,85,456.37c91.58,73.87,249.6,74.48,341.93,0C514.15,386.05,519.61,267.73,460.05,183.27Zm-19.22-23.88c-50.43-50.24-106.34-74.24-170.29-77.7,0-28.12,8.14-53.07,36-51.63L308.08.11C262-2.27,240.51,35,240.51,81.74c-67.17,3.87-121.67,30.16-169.33,77.65,47.47,19,74.54-.44,120.57-24.07-16.51,37-33.22,63.82-13.39,111.39,56.62-11.6,63.7-45.54,77.65-78.23,14.69,34.44,21.88,67.2,77.63,78.28,20.62-49.3,1.91-77.18-13.46-111.63C365.43,158.53,392.83,178.55,440.83,159.39Z"
                  transform="translate(-12.51 0)"
                />
              </SvgIcon>
              Salsa Contest
            </Link>,
            <Link
              key="past-winners"
              to="/past-winners"
              className={classes.dropdownLink}
            >
              <FontAwesomeIcon
                className={classes.dropdownIcons}
                icon={faTrophyAlt}
              />
              Past Winners
            </Link>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="Lineups"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          buttonIcon={QueueMusicIcon}
          dropdownList={[
            <Link
              key="country-edge-lineup"
              to="/country-edge-lineup"
              className={classes.dropdownLink}
            >
              <FontAwesomeIcon
                className={classNames(classes.dropdownIcons, 'fa-fw')}
                icon={faHatCowboy}
              />
              Country Edge
            </Link>,
            <Link
              key="chilimania-lineup"
              to="/chilimania-lineup"
              className={classes.dropdownLink}
            >
              <FontAwesomeIcon
                className={classNames(classes.dropdownIcons, 'fa-fw')}
                icon={faPepperHot}
              />
              Chilimania
            </Link>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          navDropdown
          hoverColor={dropdownHoverColor}
          buttonText="Support Us"
          buttonProps={{
            className: classes.navLink,
            color: 'transparent',
          }}
          buttonIcon={LoyaltyIcon}
          dropdownList={[
            <Link
              key="support-us"
              to="/support-us"
              className={classes.dropdownLink}
            >
              <FontAwesomeIcon
                className={classNames(classes.dropdownIcons, 'fa-fw')}
                icon={faHandHoldingUsd}
              />
              Contribute
            </Link>,
            <Link
              key="sponsors"
              to="/sponsors"
              className={classes.dropdownLink}
            >
              <FontAwesomeIcon
                className={classNames(classes.dropdownIcons, 'fa-fw')}
                icon={faClipboardList}
              />
              Our Sponsors
            </Link>,
            // <a
            //   key="volunteer"
            //   href="https://www.signupgenius.com/go/70A0A4FABAF2FA0F85-57595717-chilimania#/"
            //   className={classes.dropdownLink}
            //   target="_blank"
            //   rel="noopener noreferrer"
            // >
            //   <AssignmentIndIcon className={classes.dropdownIcons} />
            //   Volunteer
            // </a>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="/schedule" className={classes.linkWrapper}>
          <Button className={classes.navLink} color="transparent">
            <EventNoteIcon />
            Schedule
          </Button>
        </Link>
      </ListItem>
      <ListItem className={classes.listItem}>
        <div className={classes.navLinkModal}>
          <ContactForm />
        </div>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Link to="/register" className={classes.linkWrapper}>
          <Button
            color={
              typeof window !== 'undefined' && window.innerWidth < 960
                ? 'info'
                : 'primary'
            }
            target="_blank"
            className={classes.navButton}
            round
          >
            <ShoppingCart /> Cook-off Registration
          </Button>
        </Link>
      </ListItem>
    </List>
  );
}

HeaderLinks.defaultProps = {
  hoverColor: 'primary',
};

HeaderLinks.propTypes = {
  dropdownHoverColor: PropTypes.oneOf([
    'dark',
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    'rose',
  ]),
};
